import { container } from '../container';
import type { ICoreDataWrapper } from '../exception';
import type { I_Playbook, Playbooks } from '../types/playbook';
import type {
    IGetSearchSuggestApiData,
    IGetSearchSuggestApiParams,
} from './smart.api.types'
import type { IQueryRoot } from '../types/query';

/**
 * 页面preview接口 - 请求参数
 */
export interface ISrpPreviewApiRequest {
    /**
     * 专利、文献均从简单搜索开始
     * 专利: Playbooks.SMART
     * 文献: Playbooks.LITERATURE
     */
    playbook: I_Playbook,
    /**
     * query文本
     */
    q?: string,
    q_s?: IQueryRoot | null,
}

/**
 * 页面preview接口 - 返回参数
 */
export interface ISrpPreviewApiResponse {
    playbook: Playbooks,
    /**
     * query文本
     */
    q?: string,
    /**
     * 长文本会转成qid
     */
    qid?: string,
    novelty_id?: string,
    bulk_id?: string
}

/**
 * 获取最近搜索历史接口 - 请求参数
 */
export interface IGetRecentHistoryApiParams {
    /**
     * 产品类型，支持多个，逗号分隔
     * 例如: 'ip,material'
     */
    product_types?: string;
}

export class SmartApis {
    static getSearchSuggestApi(params: IGetSearchSuggestApiParams) {
        const {
            fields,
            keyword,
        } = params
        return container.RnDHttp.post<ICoreDataWrapper<IGetSearchSuggestApiData>>({
            url: `${process.env.VUE_APP_EUREKA_SERVICE_URI}/eureka/smart/suggest`,
            data: {
                fields,
                keyword,
                n: 5,
            },
        }).then(res => {
            return res.data
        })
    }

    static getPatentRecentHistory(params?: IGetRecentHistoryApiParams) {
        return container.RnDHttp.post<ICoreDataWrapper<{ playbook: string; query: (IQueryRoot | string) }[]>>({
            url: `${process.env.VUE_APP_EUREKA_SERVICE_URI}/eureka/search/recent-history`,
            params,
        }).then(res => {
            return res.data;
        });
    }

    static previewSemantic(data: ISrpPreviewApiRequest): Promise<ISrpPreviewApiResponse> {
        return container.RnDHttp.post({
            url: `${process.env.VUE_APP_EUREKA_SERVICE_URI}/eureka/search/novelty-search-preview`,
            data,
        }).then(res => {
            return res.data
        })
    }

    static preview(data: ISrpPreviewApiRequest): Promise<ISrpPreviewApiResponse> {
        return container.RnDHttp.post({
            url: `${process.env.VUE_APP_EUREKA_SERVICE_URI}/eureka/search/preview`,
            data,
        }).then(res => {
            return res.data
        })
    }

    static previewCount(data: ISrpPreviewApiRequest): Promise<number> {
        return container.RnDHttp.post({
            url: `${process.env.VUE_APP_EUREKA_SERVICE_URI}/eureka/search/preview/count`,
            data,
        }).then(res => {
            return res.data
        })
    }

    static previewPatentOrPaper(data: ISrpPreviewApiRequest): Promise<ISrpPreviewApiResponse> {
        return container.RnDHttp.post({
            url: `${process.env.VUE_APP_EUREKA_SERVICE_URI}/eureka/search/preview`,
            data,
            cache: true,
        }).then(res => {
            return res.data
        })
    }

    static clearImageRecentHistory() {
        return container.RnDHttp.delete({
            url: `${process.env.VUE_APP_EUREKA_SERVICE_URI}/eureka/search/clear-image-recent-history`,
        }).then(res => {
            return res.data
        })
    }
}
